import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  className?: string;
  span?: SizeProps;
  offset?: SizeProps;
  auto?: AutoProps;
  order?: number;
  align?: string;
}>;

type SizeProps = Sizes | number;

interface AutoProps {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
}
interface Sizes {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

const Column = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { className, span, offset, align, auto, order, children } = props;

  const spanClasses = () => {
    let classNames = '';
    if (span) {
      if (typeof span === 'number') {
        classNames += 'clr-col-' + span;
      } else {
        classNames += span.xs ? 'clr-col-' + span.xs : '';
        classNames += span.sm ? ' clr-col-sm-' + span.sm : '';
        classNames += span.md ? ' clr-col-md-' + span.md : '';
        classNames += span.lg ? ' clr-col-lg-' + span.lg : '';
        classNames += span.xl ? ' clr-col-xl-' + span.xl : '';
      }
    } else if (!auto) {
      classNames += 'clr-col';
    }
    return classNames;
  };

  const offsetClasses = () => {
    let classNames = '';
    if (offset) {
      if (typeof offset === 'number') {
        classNames += ' clr-offset-' + offset;
      } else {
        classNames += offset.xs ? ' clr-offset-' + offset.xs : '';
        classNames += offset.sm ? ' clr-offset-sm-' + offset.sm : '';
        classNames += offset.md ? ' clr-offset-md-' + offset.md : '';
        classNames += offset.lg ? ' clr-offset-lg-' + offset.lg : '';
        classNames += offset.xl ? ' clr-offset-xl-' + offset.xl : '';
      }
    }
    return classNames;
  };

  const autoClasses = () => {
    let classNames = '';
    if (auto) {
      classNames += auto.xs ? ' clr-col-auto' : '';
      classNames += auto.sm ? ' clr-col-sm-auto' : '';
      classNames += auto.md ? ' clr-col-md-auto' : '';
      classNames += auto.lg ? ' clr-col-lg-auto' : '';
      classNames += auto.xl ? ' clr-col-xl-auto' : '';
    }
    return classNames;
  };

  const getClassNames = () => {
    let classNames = '';
    classNames += spanClasses();
    classNames += offsetClasses();
    classNames += autoClasses();
    if (order) {
      classNames += ' clr-order-' + order;
    }
    if (align) {
      classNames += ' clr-align-self-' + align;
    }
    if (className) {
      classNames += ' ' + className;
    }
    return classNames;
  };
  return (
    <div ref={ref} className={getClassNames()}>
      {children}
    </div>
  );
});

export default Column;
